<template>
	<div id="qs_left1">
		<div class="cc-header">日常评价
			<div class="title_tab">
				<div class="tab_line" style="margin-right: 5px;">
					<div class="legend-color" style="background-color: #ffac05;"></div> 表扬
				</div>
				<div class="tab_line">
					<div class="legend-color" style="background-color: #8383ff;"></div> 待改进
				</div>
			</div>
		</div>
		<div class="main-value" id="daily_active"></div>
		<div class="main-table">
			<table class="table">
				<thead>
					<tr>
						<th width="40px">排名</th>
						<th width="170px">评价内容</th>
						<th class="switch_btn" id="switchBtn" data-val="good" v-on:click="changeType()">{{typeName}} <img src="../../assets/img/switch.gif"></th>
					</tr>
				</thead>
			</table>
			<dv-scroll-board :config="config" class="rankChart" />
		</div>
	</div>
</template>

<script>
	var storage = window.localStorage;
	var orgCode = storage.getItem("orgCode");
	const echarts = require("echarts");
	export default {
		data() {
			return {
				typeName: "表扬比率",
				config: {}
			};
		},
		mounted() {
			this.initData();
			this.changeType();
			// 定时器刷新，1小时
			let _this = this;
			// setInterval(() => {
			// 	this.changeType();
			// }, 1000 * 5);
			this.interval = setInterval(() => {
				_this.initData();
			}, 1000 * 60 * 60);
		},
		beforeDestroy() {
			clearInterval(this.interval);
		},
		methods: {
			initData() {
				// 基于准备好的dom，初始化echarts实例
				let dailyEvalCensusChart = echarts.init(document.getElementById("daily_active"));
				this.$http.get("/dataView/quality/getDailyEvalCensus?orgCode=" + orgCode).then(res => {
					if (res.data.code === 200) {
						var result = res.data.result;
						var option = {
							tooltip: {
								trigger: 'item',
								formatter: function (params) {
									var relVal = '评价次数<br/>' + params.marker + '&nbsp;' + params.name + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>' + params.value + '</b>次';
									return relVal
								}
							},
							grid: {
								top: "0",
								bottom: "0",
							},
							series: [{
								name: '数量',
								type: 'pie',
								radius: ['35%', '85%'],
								center: ['50%', '50%'],
								avoidLabelOverlap: false,
								itemStyle: {
									normal: {
										borderRadius: 6,
										borderColor: '#181b37',
										borderWidth: 2,
										label: {
											position: 'inner',
											textStyle: {
												color: '#ffffff',
												fontSize: fontSize(0.15)
											},
											formatter: function(p) {
												return p.percent.toFixed(0) + "%";
											}
										}
									}
								},
								emphasis: {
									label: {
										show: true,
										fontSize: fontSize(0.15),
										color: '#fff'
									}
								},
								labelLine: {
									normal: {
										length: 4,
										length2: 4
									}
								},
								label: {
									normal: {
										padding: [0, -5],
									}
								},
								data: [{
										value: result.goodNum,
										name: '表扬',
										itemStyle: {
											color: '#ffac05',
										}

									},
									{
										value: result.badNum,
										name: '待改进',
										itemStyle: {
											color: '#8383ff',
										}

									}
								]
							}]
						};
						dailyEvalCensusChart.setOption(option);
						// 响应式变化
						window.addEventListener("resize", () => dailyEvalCensusChart.resize(), false);
					}
				});
			},
			changeType: function(){
				let _this = this;
				var type = document.getElementById("switchBtn").getAttribute("data-val");
				if(type == "good"){
					_this.typeName = "表扬比率";
					document.getElementById("switchBtn").setAttribute("data-val","bad");
				}else{
					_this.typeName = "待改进比率";
					document.getElementById("switchBtn").setAttribute("data-val","good");
				}
				//比率排名情况
				this.$http.get("/dataView/quality/getDailyEvalRank?orgCode=" + orgCode + "&sort="+type).then(res => {
					if (res.data.code === 200) {
						var result = res.data.result;
						var data = [];
						for (var i = 0; i < result.length; i++) {
							if(i == 0){
								data.push(
									['<span class="table_font" style="color:#55ffff;">01</span>',
									'<span class="table_font">'+result[i].itemName+'</span>',
									'<div class="daily_progress"><div class ="daily_pro_txt daily_pro_tag" style="width:'+result[i].itemRatio+'%;">'+result[i].itemRatio+'%</div></div>']
								);
							}else if(i == 1){
								data.push(
									['<span class="table_font" style="color:#ffaa7f;">02</span>',
									'<span class="table_font">'+result[i].itemName+'</span>',
									'<div class="daily_progress"><div class ="daily_pro_txt daily_pro_tag" style="width:'+result[i].itemRatio+'%;">'+result[i].itemRatio+'%</div></div>']
								);
							}else if(i == 2){
								data.push(
									['<span class="table_font" style="color:#ff696b;">03</span>',
									'<span class="table_font">'+result[i].itemName+'</span>',
									'<div class="daily_progress"><div class ="daily_pro_txt daily_pro_tag" style="width:'+result[i].itemRatio+'%;">'+result[i].itemRatio+'%</div></div>']
								);
							}else{
								if(i < 9){
									data.push(
										['<span class="table_font">0'+(i+1)+'</span>',
										'<span class="table_font">'+result[i].itemName+'</span>',
										'<div class="daily_progress"><div class ="daily_pro_txt daily_pro_tag" style="width:'+result[i].itemRatio+'%;">'+result[i].itemRatio+'%</div></div>']
									);
								}else{
									data.push(
										['<span class="table_font">'+(i+1)+'</span>',
										'<span class="table_font">'+result[i].itemName+'</span>',
										'<div class="daily_progress"><div class ="daily_pro_txt daily_pro_tag" style="width:'+result[i].itemRatio+'%;">'+result[i].itemRatio+'%</div></div>']
									);
								}
							}
						}
						var config = {
							data: data,
							columnWidth: [50, 170],
							rowNum: 7, //表格行数
							oddRowBGC: 'rgba(85, 85, 255, 0.1)',
							evenRowBGC: 'rgba(0, 170, 255, 0.01)',
							waitTime: 1500000,
							fontSize: 20,
							unit: "%" //数值单位
						};
						_this.config = config;
					}
				});
			}
		},
		destroyed() {
			window.onresize = null;
		}
	};

	function fontSize(res) {
		let clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
		if (!clientWidth) return;
		let fontSize = 100 * (clientWidth / 1920);
		return res * fontSize;
	}
</script>

<style lang="scss">
	#qs_left1 {
		height: 100%;
		padding: 0 5%;

		.table_font {
			font-size: 0.2rem;
		}

		.daily_progress {
			width: 100%;
			background-color: #373753;
			border-radius: 0.1rem;
			display: inline-block;
		}

		.daily_pro_txt {
			text-align: right;
			padding-right: 0.1rem;
			line-height: 0.18rem;
			font-size: 0.15rem;
			color: #fff;
		}

		.daily_pro_tag {
			width: 65%;
			padding-left: 0.05rem;
			border-radius: 0.1rem;
			background-color: #55ffff;
			background-image: linear-gradient(to right, #974cff, #5555ff);
		}

		.cc-header {
			width: 100%;
			padding-top: 1%;
			color: #55ffff;
			font-size: 0.3rem;
			display: flex;
			align-items: center;
			position: relative;

			.title_tab {
				position: absolute;
				right: 0.2rem;
				font-size: 0.2rem;
				height: 0.2rem;
				display: flex;
				align-items: center;
				color: #d3d6ff;

				.legend-color {
					display: inline-block;
					width: 0.3rem;
					height: 0.2rem;
					border-radius: 0.05rem;
					margin-right: 0.05rem;
					vertical-align: text-bottom;
				}
			}
		}

		.rankChart{
			.ceil{
				text-align: center;
			}
		}

		@media screen and (min-width: 768px) and (max-width: 992px) {
			.cc-header {
				height: 10%;
				padding-left: 3%;
			}

			.main-value {
				height: 30%;
			}

			.main-value canvas {
				width: 100%;
				height: 100%;
			}

			.main-table {
				height: 30%;
				position: relative;
				padding-top: 2%;

				.table {
					width: 100%;
					border-bottom: 1px solid #86FDE8;
					color: #d3d6ff;
					margin-bottom: 0.1rem;
				}

				.table thead th {
					padding: 0.1rem 0.05rem;
					font-size: 0.2rem;
				}

				.table thead th:nth-child(1) {
					text-align: left;
				}

				.table th.switch_btn {
					color: #55ffff;
				}

				.switch_btn img {
					width: 20%;
					vertical-align: bottom;
				}

				.switch_btn:hover {
					cursor: pointer;
				}

				.rankChart {
					width: 100%;
					height: 34vh;
					line-height: 0.18rem;
					color: #d3d6ff;

					.rank {
						width: 65px;
						padding: 0.05rem;
						font-size: 0.25rem;
						color: #55ffff;
					}

					.info-name {
						font-size: 0.25rem;
						padding: 0.05rem;
					}

					.ranking-value {
						font-size: 0.25rem;
						padding: 0.05rem;
					}

					.inside-column {
						height: 0.01rem;
					}

					
				}
			}
		}

		@media screen and (min-width: 1200px) and (max-width: 1920px) {
			.cc-header {
				height: 10%;
			}
			.main-value {
				height: 30%;
			}

			.main-value canvas {
				width: 100%;
				height: 100%;
			}

			.main-table {
				height: 60%;
				position: relative;
				padding-top: 2%;

				.table {
					width: 100%;
					border-bottom: 1px solid #86FDE8;
					color: #d3d6ff;
					margin-bottom: 0.1rem;
				}

				.table thead th {
					padding: 0.1rem 0.05rem;
					font-size: 0.2rem;
				}

				.table thead th:nth-child(1) {
					text-align: left;
				}

				.table th.switch_btn {
					color: #55ffff;
				}

				.switch_btn img {
					width: 20%;
					vertical-align: bottom;
				}

				.switch_btn:hover {
					cursor: pointer;
				}

				.rankChart {
					width: 100%;
					height: 34vh;
					line-height: 0.18rem;
					color: #d3d6ff;

					.rank {
						width: 65px;
						padding: 0.05rem;
						font-size: 0.25rem;
						color: #55ffff;
					}

					.info-name {
						font-size: 0.25rem;
						padding: 0.05rem;
					}

					.ranking-value {
						font-size: 0.25rem;
						padding: 0.05rem;
					}

					.inside-column {
						height: 0.01rem;
					}
				}

				.title {
					line-height: 0.8rem;

					.title-text {
						font-size: 0.45rem !important;
						width: 100%;
						font-weight: 600;
						background-image: linear-gradient(135deg, #00c3d4, #7243e1);
						-webkit-background-clip: text;
						color: transparent;
					}
				}
			}
		}
	}
</style>
